import { createContext, useContext } from "react";

export interface AuthContextType {
    userId: string | null;
    email: string | null;
    displayName: string | null;
    roles: string[];
    isReadOnly: boolean;
    isAuthenticated: boolean;
    isAuthReady: boolean;
    userSyncFailed: boolean;
    accessToken: string | null;
    sessionTimeRemaining: number | null;

    login: () => Promise<void>;
    logout: () => Promise<void>;
    maintainSession: () => Promise<boolean>;
}

export const AuthContext = createContext<AuthContextType>({
    userId: null,
    email: null,
    displayName: null,
    roles: [],
    isReadOnly: true, // Default to true for safety
    isAuthenticated: false,
    isAuthReady: false,
    userSyncFailed: false,
    accessToken: null,
    sessionTimeRemaining: null,
    login: async () => { },
    logout: async () => { },
    maintainSession: async () => false,
});

export const useAuth = () => useContext(AuthContext);